'use strict';

var templates = require('../templates');
var fobclient = require('..');
var OrgaIdent = require('../entity').OrgaIdent;

module.exports = function (connection) {
  return {
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(OrgaIdent, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    byTypEquals: function byTypEquals(typ, additionalParams) {
      return templates.searchTemplate(connection)(OrgaIdent, 'byTypEquals', 'typ')(typ, additionalParams);
    },
    byTypLike: function byTypLike(typ, additionalParams) {
      return templates.searchTemplate(connection)(OrgaIdent, 'byTypLike', 'typ')(typ, additionalParams);
    },
    byWertEquals: function byWertEquals(wert, additionalParams) {
      return templates.searchTemplate(connection)(OrgaIdent, 'byWertEquals', 'wert')(wert, additionalParams);
    },
    byWertLike: function byWertLike(wert, additionalParams) {
      return templates.searchTemplate(connection)(OrgaIdent, 'byWertLike', 'wert')(wert, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(OrgaIdent, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('orgaident')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/orgaIdent.js
// module id = 29pJ
// module chunks = 0